import { renderInlineCode } from '~/shared/lib/inline-code'
import { Text } from '~/shared/ui'
import { BLIND_REVIEW_REMINDERS } from '../config'

export function BlindReviewReminder() {
  return (
    <div className="border-alert-info-message bg-surface-low rounded-lg border-l-4 px-4 py-3">
      <Text appearance="SUBTITLE2">Blind review</Text>
      <ul className="m-0 mt-1 flex list-disc flex-col gap-0.5 pl-5">
        {BLIND_REVIEW_REMINDERS.map((reminder) => (
          <li
            key={reminder}
            className="text-[14px] leading-5"
          >
            {renderInlineCode(reminder)}
          </li>
        ))}
      </ul>
    </div>
  )
}
